// @flow
import * as React from 'react';

export default class AdminAutoMessageSftpCredentials extends React.PureComponent<*, *> {
  render() {
    return null;
  }
}
